import { render, staticRenderFns } from "./batchOperations.vue?vue&type=template&id=dc2b5608&scoped=true&"
import script from "./batchOperations.vue?vue&type=script&lang=js&"
export * from "./batchOperations.vue?vue&type=script&lang=js&"
import style0 from "./batchOperations.vue?vue&type=style&index=0&id=dc2b5608&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2b5608",
  null
  
)

export default component.exports